import "./styles/global.css";
import 'react-quill-new/dist/quill.snow.css';

import { RouterProvider } from "react-router-dom";
import { router } from "./routes";

const App = () => <RouterProvider router={router} />;

export default App;
